import { NgaModule } from '../../../theme/nga.module';
import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface DialogInfo {
  header: string;
  message: Observable<string>;
}

@Component({
  selector: 'result-dialog',
  template: `
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="close" aria-label="Close" (click)="authResult(true)">
            &times;
          </div>
          <h4 class="modal-title">{{ heading }}</h4>
        </div>

        <div class="modal-body">
          <div style="display:inline-block"></div>
          {{ message$ }}
        </div>
      </div>
    </div>
  `,
})
export class MessageDialog {
  heading: string = 'Information';
  message$: Observable<string>;

  constructor(
    public dialogref: MatDialogRef<MessageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogInfo
  ) {
    console.log({ data: data });
    this.heading = data.header;
    this.message$ = data.message;
  }

  public authResult(res: any) {
    console.log({ messageDialog: res });
    this.dialogref.close(res);
  }
}
